import {
  createReducer,
} from 'helpers/ReducerUtil'
import {
  UPDATE_VALUES
} from './constants'

const updateValues = (prevValues, action) => {
  const { values } = action
  return values.map(valueObj => ({value: valueObj.value}))
}

const dropdownReducer = createReducer([], {
  [UPDATE_VALUES]: updateValues
})

export default dropdownReducer
